import { jsx as m } from "react/jsx-runtime";
import { useMemo as H, useState as M, useEffect as T } from "react";
import { LinkIcon as V } from "../../icons/link-icon.mjs";
import { twMerge as S } from "tailwind-merge";
import { FormInput as I } from "./form-input.mjs";
import { FormSelectInline as N } from "../form-select/form-select-inline.mjs";
import { UrlSchemeEnum as i } from "./url-scheme.enum.mjs";
import { copyTextToClipboard as U } from "../../utils/copy-to-clipboard.mjs";
import { useTranslation as A } from "../../i18n/hooks.mjs";
const L = (t) => [
  {
    id: i.Https,
    caption: i.Https,
    customCaption: t("public_pages_purchase.input.url.site")
  },
  {
    id: i.Mailto,
    caption: i.Mailto,
    customCaption: t("public_pages_purchase.input.url.mail")
  },
  {
    id: i.Tel,
    caption: i.Tel,
    customCaption: t("public_pages_purchase.input.url.tel")
  }
], k = (t) => {
  var e;
  return ((e = t[0]) == null ? void 0 : e.id) ?? i.Https;
}, z = {
  [i.Https]: "example.com",
  [i.Mailto]: "contact@example.com",
  [i.Tel]: "+15551234567"
}, f = (t, e) => {
  var n;
  return (n = e.find((a) => t.startsWith(a.id))) == null ? void 0 : n.id;
}, b = (t, e) => f(t, e) ?? k(e), D = (t) => z[t], p = (t, e) => {
  if (!t) return t;
  const n = f(t, e);
  return n && t.startsWith(n) ? t.slice(n.length) : t;
}, K = ({
  onChange: t,
  value: e = "",
  withCopyButton: n,
  buttonClassName: a,
  linkIconClassName: x,
  placeholder: C,
  schemeOptions: l,
  ...y
}) => {
  var h;
  const { t: u } = A(), o = H(
    () => l ?? L(u).slice(0, 1),
    [l, u]
  ), [c, d] = M(b(e, o));
  T(() => {
    if (!e) return;
    const r = b(e, o);
    r !== c && d(r);
  }, [c, o, e]);
  const _ = p(e, o), w = C ?? (l ? D(c) : void 0), F = ({ target: { value: r } }) => {
    if (!r) return t("");
    const s = f(r, o);
    if (s) {
      s !== c && d(s);
      const g = p(r, o);
      if (!g) return t("");
      t(s + g);
    } else
      t(c + p(r, o));
  }, E = (r) => {
    if (!r || (d(r), !e)) return;
    const s = p(e, o);
    if (!s) return t("");
    t(r + s);
  };
  return /* @__PURE__ */ m(
    I,
    {
      type: "url",
      addonBefore: o.length > 1 ? /* @__PURE__ */ m(
        N,
        {
          withoutCloseIcon: !0,
          data: o,
          value: c,
          optionsClassName: "min-w-0",
          captionClassName: "no-underline w-max",
          onChange: E
        }
      ) : (h = o[0]) == null ? void 0 : h.caption,
      value: _,
      placeholder: w,
      onChange: F,
      addonAfterClassName: "p-0 sm:p-0 lg:p-0 border-0",
      addonAfter: n && /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          onClick: async (r) => {
            r.preventDefault(), await U(e, u);
          },
          className: S(
            "bg-brand-primary hover:bg-brand-primary-hover focus-ring flex h-full items-center justify-center rounded-r-lg px-2 py-2.5 sm:px-4",
            a
          ),
          children: /* @__PURE__ */ m(
            V,
            {
              className: S(
                "fill-background-secondary h-[15px] w-[15px] sm:h-[20px] sm:w-[20px]",
                x
              )
            }
          )
        }
      ),
      ...y
    }
  );
};
export {
  K as FormInputUrl,
  L as getUrlSchemeOptions
};
